<div class="assessment-complete-container" *ngIf="config.content && !(loading | async)">
  <img src="/assets/complete_checkmark.svg" data-test="complete-checkmark-image" />
  <h2>{{ isProviderCompleted ? 'Assessment complete' : 'Well done'}}</h2>

  <div class="text-wrapper">
    <p>{{ isProviderCompleted ? providerCqCompletionMessage : staticIntroContent }}</p>
    <span *ngIf="!isProviderCompleted" [innerHTML]="helpText | unsafeHtml"></span>
  </div>

  <iris-button-container class="complete-step-buttons">
    <iris-button
      *ngIf="!isProviderCompleted"
      class="done-button"
      (click)="onClickDone()"
      [type]="irisButtonTypes.PRIMARY"
      data-test="flows-complete-exit-button"
    >
      {{ component.done  }}
    </iris-button>

    <iris-button
      *ngIf="isProviderCompleted"
      class="done-button"
      (click)="onClickDone()"
      [type]="irisButtonTypes.SECONDARY"
      data-test="flows-complete-done-button"
    >
      Done
    </iris-button>

    <iris-button
      *ngIf="hasNextAssessment"
      class="next-assessment-button"
      (click)="onClickNextAssessment()"
      [type]="irisButtonTypes.PRIMARY"
      data-test="flows-complete-next-assessment-button"
    >
      Next assessment
    </iris-button>
  </iris-button-container>
</div>

<div class="loader" *ngIf="(loading | async)"></div>